import { cva } from 'class-variance-authority';

const toastBadgeVariants = cva('rounded-pill flex size-6 shrink-0 items-center justify-center', {
  variants: {
    'variant': {
      'info': 'bg-chip-info-bg',
      'success': 'bg-chip-success-bg',
      'error': 'bg-chip-danger-bg',
    },
  },
  defaultVariants: { variant: 'info' },
});

const toastDotVariants = cva('rounded-pill size-2 shrink-0', {
  variants: {
    'variant': {
      'info': 'bg-chip-info-fg',
      'success': 'bg-chip-success-fg',
      'error': 'bg-chip-danger-fg',
    },
  },
  defaultVariants: { variant: 'info' },
});

export {
  toastBadgeVariants,
  toastDotVariants,
};
